/* =========================================================
   Plain Jane - collection card photo arrows
   Lets customers look through a product's photos straight
   from the collection grid, without opening the product.
   Works alongside collection-product-hover.js: the second
   <img> is kept in sync as "the next photo", so the theme's
   hover swap and mobile swipe still behave correctly.
   ========================================================= */
(function () {
  'use strict';

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches ? el.matches(selector) : el.msMatchesSelector(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function readList(card) {
    var raw = card.getAttribute('data-pj-cc-images');
    if (!raw) return [];
    try {
      var list = JSON.parse(raw);
      return Object.prototype.toString.call(list) === '[object Array]' ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setSource(img, url) {
    if (!img || !url) return;
    /* drop everything lazysizes / srcset could use to override us */
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.removeAttribute('sizes');
    img.removeAttribute('data-sizes');
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);
  }

  function preload(url) {
    if (!url) return;
    var i = new Image();
    i.src = url;
  }

  function show(card, index) {
    var list = readList(card);
    var total = list.length;
    if (total < 2) return;

    index = ((index % total) + total) % total;
    card.setAttribute('data-pj-cc-index', String(index));

    var link = card.querySelector('.collection-product-container');
    if (!link) return;

    var imgs = link.querySelectorAll('img');
    var next = list[(index + 1) % total];

    setSource(imgs[0], list[index]);
    if (imgs[1]) setSource(imgs[1], next);

    /* the theme's hover / swipe code drives these inline styles - reset them
       so the photo we just picked is the one on screen */
    if (imgs[0]) {
      imgs[0].style.visibility = 'visible';
      imgs[0].style.opacity = '';
      imgs[0].style.filter = '';
    }
    if (imgs[1]) {
      imgs[1].style.visibility = 'hidden';
      imgs[1].style.opacity = '';
      imgs[1].style.filter = '';
    }

    preload(next);
    preload(list[(index - 1 + total) % total]);
  }

  function step(card, direction) {
    var current = parseInt(card.getAttribute('data-pj-cc-index') || '0', 10);
    if (isNaN(current)) current = 0;
    show(card, current + direction);
  }

  /* ---------------------------------------------------------- arrows */
  document.addEventListener('click', function (e) {
    var arrow = closest(e.target, '[data-pj-nav="cc-prev"], [data-pj-nav="cc-next"]');
    if (!arrow) return;

    /* never let the click reach the product link */
    e.preventDefault();
    e.stopPropagation();

    var card = closest(arrow, '.pj-cc-media');
    if (!card) return;
    step(card, arrow.getAttribute('data-pj-nav') === 'cc-next' ? 1 : -1);
  });

  /* ---------------------------------------------------------- swipe */
  function bindSwipe() {
    var cards = document.querySelectorAll('.pj-cc-media');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.getAttribute('data-pj-cc-swipe') === 'on') return;
      card.setAttribute('data-pj-cc-swipe', 'on');

      var x0 = null;
      var y0 = null;

      card.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        x0 = t.clientX;
        y0 = t.clientY;
      }, { passive: true });

      card.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0;
        var dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 45) return;
        if (Math.abs(dx) < Math.abs(dy) * 1.3) return;
        step(card, dx < 0 ? 1 : -1);
      }, { passive: true });
    });
  }

  function init() {
    bindSwipe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();